<!--
일괄기능 — 대금상환 「송금 일괄처리」 (TASK-161 §0-10 · 결정 27 — 구매요청과 같은 공용 배치 컴포넌트 job · 라벨 결정 29·30 · 날짜 결정 28)
------------------------------------
 - 버튼 (blade) → jobInit() → 모달. 대상 = 선택 항목 (CodPaymentIndexTrait::codBatchJson 의 items)
 - 송금 가능 = 정산확정 건만 (사이클 14 결정 49 — 창고지급완료 건은 정산확정 선행). 정산확정이 아닌 건이 섞이면 안내하고 차단 (송금 확인 비활성 — 선택 해제 후 재시도)
 - 상태값 = batch.states (App\Code\CodPayment\State — 결정 49 d 재번호, 숫자 직접 비교 금지)
 - 송금일 (기본 오늘, 필수 — flatpickr Y-m-d, date-input.js) → POST /admin/cod-payments/settlements (ids[] + settled_date)
 - 서버 Logic 거부 문구 = 그대로 alert (전체 롤백) · 성공 = 서버 msg alert 후 새로고침
-->
<template>
    <div ref="modal" uk-modal esc-close="false" bg-close="false" class="cdp-popup cdp-settle-popup">
        <div class="uk-modal-dialog uk-modal-body uk-text-left">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">송금 일괄처리</h3>

            <div class="uk-margin-small">
                선택 {{ targets.length }}건 (정산확정 {{ paidCount }}건)
                <div class="uk-text-danger cdp-settle-blocked" v-if="otherCount > 0">
                    정산확정이 아닌 건이 {{ otherCount }}건 섞여 있어 송금완료 처리할 수 없습니다.
                    정산확정 건만 선택한 뒤 다시 진행해 주세요 (창고지급완료 건은 먼저 정산확정).
                </div>
            </div>

            <div class="uk-margin">
                <label class="uk-form-label">송금일 (필수)</label>
                <div class="uk-form-controls">
                    <input ref="settledDate" class="uk-input cdp-settled-date" type="text" v-model="inputSettledDate" placeholder="e.g. 2025-01-01"/>
                </div>
            </div>

            <div class="uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                <button class="uk-button uk-button-primary cdp-settle-submit" type="button"
                        :disabled="busy || otherCount > 0 || paidCount === 0 || inputSettledDate === ''" @click="submit">송금 확인</button>
            </div>
        </div>
    </div>
</template>

<script>
    import CodPopupMixin from '../../cod-payment/popup-mixin';
    import { bindDateInput, setDateInput, destroyDateInput } from '../../cod-payment/date-input';

    export default {
        mixins: [CodPopupMixin],
        props: {
            /**
             * 일괄기능 공유data (CodPaymentIndexTrait::codBatchJson)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 작업대상 아이템 (jobInit 시점 선택 항목)
                targets: [],

                inputSettledDate: '',
            };
        },
        computed: {
            // 송금 대상 = 정산확정 (App\Code\CodPayment\State::CONFIRMED — batch.states.confirmed)
            paidCount() {
                let confirmed = parseInt(this.batch.states.confirmed, 10);
                return this.targets.filter((item) => parseInt(item.state, 10) === confirmed).length;
            },

            // 송금 대상이 아닌 (정산확정이 아닌) 선택 건수
            otherCount() {
                return this.targets.length - this.paidCount;
            },
        },
        created() {
            // flatpickr instance (비반응)
            this.settledDatePicker = null;
        },
        mounted() {
            // 결정 28 — 날짜 포맷 Y-m-d (flatpickr)
            this.settledDatePicker = bindDateInput(this.$refs.settledDate, (value) => {
                this.inputSettledDate = value;
            });
        },
        beforeDestroy() {
            destroyDateInput(this.settledDatePicker);
            this.settledDatePicker = null;
        },
        methods: {
            // 작업초기화 (버튼 클릭 → 모달)
            jobInit() {
                this.targets = _.filter(this.batch.items, ['checked', true]);
                if (this.targets.length === 0) {
                    alert('선택된 대금상환이 없습니다.');
                    return;
                }
                if (this.paidCount === 0) {
                    alert('송금완료 처리할 수 있는 정산확정 건이 없습니다.');
                    return;
                }

                this.inputSettledDate = this.today();
                setDateInput(this.settledDatePicker, this.inputSettledDate);
                this.show();
            },

            submit() {
                if (this.busy || this.otherCount > 0 || this.paidCount === 0 || this.inputSettledDate === '') {
                    return;
                }
                this.request('post', '/admin/cod-payments/settlements', {
                    ids: _.map(this.targets, 'id'),
                    settled_date: this.inputSettledDate,
                }).then(this.done);
            },
        },
    }
</script>
